import { forwardRef } from "react";
import { cn } from "@/lib/utils";
import type { HealthArea } from "instantdb/types";
import { useTranslation } from "@/hooks/useTranslation";

interface CategoryBadgeProps {
  category: HealthArea;
  isSelected: boolean;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export const CategoryBadge = forwardRef<HTMLButtonElement, CategoryBadgeProps>(
  ({ category, isSelected, onClick, disabled = false, className }, ref) => {
    const { t } = useTranslation();

    const pillStyles = isSelected
      ? "bg-secondary/15 border-secondary/20 text-secondary dark:bg-secondary/20 hover:bg-secondary/20 dark:hover:bg-secondary/25 active:bg-secondary/25"
      : disabled
        ? "bg-muted/40 border-muted-foreground/10 text-muted-foreground/50 cursor-not-allowed"
        : "bg-muted/80 border border-muted-foreground/20 text-muted-foreground hover:bg-accent hover:text-accent-foreground active:bg-accent/80";

    return (
      <button
        ref={ref}
        type="button"
        onClick={onClick}
        disabled={disabled}
        className={cn(
          "px-3 py-2 md:py-1.5 rounded-full text-md md:text-sm font-medium transition-colors duration-100 flex items-center gap-1 border",
          pillStyles,
          className,
        )}
      >
        <span>{category.symbol}</span> {t(category.title)}
      </button>
    );
  },
);

CategoryBadge.displayName = "CategoryBadge";
